import { nothing, Widget } from "../widget";

export const onlyIf = <a>(condition:boolean, widget:Widget<a>) : Widget<a> =>
  condition ? widget : nothing()



// WEBPACK FOOTER //
// ./node_modules/widgets-for-react/src/combinators/only_if.ts